import { Component, Input, OnInit } from '@angular/core';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import  * as L  from 'leaflet';

@Component({
    selector: 'app-map',
    imports: [LeafletModule],
    templateUrl: './map.component.html',
    styleUrl: './map.component.scss'
})
export class MapComponent implements OnInit {

  @Input() coordinates:any;
  @Input() height:string = "calc(90vh - 80px - 1.25rem)";
  show = false;

  options = {
    layers: [
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
         attribution: ''
      })
   ],
   zoom: 13,
   center: L.latLng(60.1699, 24.9384)
  };

  layers:any = [];

  ngOnInit() {
    this.options.center = L.latLng(this.coordinates[0], this.coordinates[1]);
    this.layers.push(L.marker(this.coordinates, {
      icon: L.icon({
        ...L.Icon.Default.prototype.options,
        iconUrl: 'marker-red.png',
        iconRetinaUrl: 'marker-red-2x.png',
        shadowUrl: ''
      })
    }));

    setTimeout(() => {
      this.show =true;
    }, 400);
  }
}
